import { render, staticRenderFns } from "./fastvaluedeal-card-step.vue?vue&type=template&id=0fac9034&scoped=true&"
import script from "./fastvaluedeal-card-step.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-card-step.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-card-step.vue?vue&type=style&index=0&id=0fac9034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac9034",
  null
  
)

export default component.exports